<div class="container">

    <a id="profileScrollAnchor"></a>

    <div class="row mt-5">

        <div class="col-12 mb-3">
            <app-pim-notification phase="Profile"></app-pim-notification>
        </div>

        <div class="col-12 col-md-8">
            <h2 class="" [attr.data-testid]="'confirmation-heading'">{{"pr.profileHeader"|translate}}</h2>
        </div>
        <div class="col-12 col-md-4 return-to-av-container">
            <p-button [outlined]="true" (click)="returnToAvailability();" [attr.data-testid]="'return-to-availability'">{{"pr.ReturnToAvailability"|translate}}</p-button>
        </div>
    </div>


    <div class="row">


        <div class="col-12" [class.col-md-8]="roomUpgrade">
            <app-profile-summary [shopCart]="shopCart" [searchParams]="searchParams"></app-profile-summary>
        </div>


        @if (roomUpgrade) {
            <div class="col-12 col-md-4">
                <app-profile-room-upgrade [upgradeItem]="roomUpgrade" [shopCart]="shopCart"></app-profile-room-upgrade>
            </div>
        }
    </div>

    @if ((extras && extras.length > 0) || (externalExtras && externalExtras.length > 0)) {
        <h2 class="mt-5" [attr.data-testid]="'extras-heading'">{{"pr.extrasHeader"|translate}}</h2>

        <app-extras [extras]="extras" [externalExtras]="externalExtras" [ticketExtraId]="ticketExtraId"></app-extras>
    }


    <h2 class="mt-5 profile-booker-details-header">{{"pr.detailsHeader"|translate}}</h2>
    @if (shopCart.getCartItemsByType('roomrate').length == 1) {
        <span class="profile-booker-details-header" roomIndex="0"></span>
    }

    @for (cartItem of shopCart.getCartItemsByType('roomrate'); track $index) {
        @if ($count > 1) {
            <h3 class="profile-booker-details-header" [attr.roomIndex]="$index">{{"pr.Room"|translate}} {{$index+1}}: {{cartItem.item.room?.pim?.name ?? cartItem.item.room?.roomName}}</h3>
        }
        <app-profile-booker-details class="profile-booker-details-component" [cartItem]="cartItem" (profileData)="handleProfileDataChange($index, $event)"></app-profile-booker-details>
    }

    <h2 class="mt-5">{{"pr.paymentSummaryHeader"|translate}}</h2>

    <app-payment-summary [shopCart]="shopCart"></app-payment-summary>



    <app-profile-payment [shopCart]="shopCart" [validationData]="validationData" [ticketExtraId]="ticketExtraId"></app-profile-payment>

    @if (paymentFailed) {
        <p-dialog [header]="'pr.paymentFailedHeader'|translate" [closable]="false" [modal]="true" [visible]="paymentFailed != null" [style]="{ width: '25rem' }" [attr.data-testid]="'booking-payment-failed'">
            <p>
                {{"pr.paymentFailedMessage"|translate}}
            </p>
            <div class="d-flex justify-content-center gap-2">
                <p-button (click)="disablePaymentFailedError()">{{"pr.continue"|translate}}</p-button>
            </div>
        </p-dialog>
    }

</div>
